import { InjectionToken } from '@angular/core';
import { SearchAsYouTypeDataProviderService } from './search-as-you-type-data-provider.service';

export const SEARCH_AS_YOU_TYPE_DATA_PROVIDER_SERVICE = new InjectionToken<SearchAsYouTypeDataProviderService>('search-as-you-type-data-provider-service');



// WEBPACK FOOTER //
// ./src/app/atoms/search-as-you-type/search-as-you-type.tokens.ts